import * as z from 'zod/mini';

export const emailSchema = z.email({ message: 'Please enter a valid email address.' });

export const passwordedLoginSchema = z.object({
  email: z.email({ message: 'Please enter a valid email address.' }),
  password: z.string(),
});
